import { render, staticRenderFns } from "./TfootTotalsByAgeAndWeek.vue?vue&type=template&id=1ff04a34"
import script from "./TfootTotalsByAgeAndWeek.vue?vue&type=script&lang=js"
export * from "./TfootTotalsByAgeAndWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports